import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const PROOF_POINTS = [
  { title: 'Local support', desc: 'Technical teams in-region, working in your time zone and context.' },
  { title: 'Data control', desc: 'Choose where workloads run and where data is stored.' },
  { title: 'Regional resilience', desc: 'Reduced dependency on distant infrastructure and long international routes.' },
  { title: 'Hybrid connectivity', desc: 'Private links between your facilities and DAAKYI Cloud regions.' }
];

const INFRA_PHOTO = 'https://images.unsplash.com/photo-1484557052118-f32bd25b45b5?w=1200&q=80&auto=format&fit=crop';

export const InfraMapSection = () => (
  <section data-testid="home-infrastructure" className="section-dark py-20 lg:py-28">
    <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <p className="text-[#F29B3D] text-xs font-semibold uppercase tracking-widest mb-4">Infrastructure</p>
          <h2 className="text-3xl lg:text-4xl font-extrabold tracking-tight mb-5">
            Infrastructure closer to the organizations it serves.
          </h2>
          <p className="text-[#93A5BC] text-[15px] leading-relaxed mb-8 max-w-[460px]">
            Our flagship region is operational today, and dedicated sovereign deployments
            can stand up wherever your regulations require. Business offices in Houston
            and Dubai connect African workloads to global markets.
          </p>

          <div className="space-y-4 mb-8">
            {PROOF_POINTS.map(p => (
              <div key={p.title} className="flex gap-3">
                <span className="w-1 shrink-0 rounded-full bg-gradient-to-b from-[#F29B3D] to-[#F29B3D] mt-1 mb-1" />
                <div>
                  <p className="text-white text-sm font-semibold">{p.title}</p>
                  <p className="text-[#93A5BC] text-sm">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <Link to="/about" data-testid="infra-view-all" className="inline-flex items-center gap-2 text-[#F29B3D] hover:text-white text-sm font-semibold transition-colors">
            View all locations <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-7">
          <div className="card-dark overflow-hidden">
            <div className="relative">
              <img
                src={INFRA_PHOTO}
                alt="Enterprise server infrastructure powering DAAKYI Cloud"
                loading="lazy"
                className="w-full h-[380px] lg:h-[460px] object-cover"
                data-testid="infra-photo"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#120836]/[0.85] via-transparent to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-6">
                <p className="text-white text-sm font-semibold mb-1">One platform, any jurisdiction.</p>
                <p className="text-[#93A5BC] text-xs max-w-[420px]">
                  The same secure-by-design platform, delivered as a dedicated sovereign
                  deployment wherever your data must live.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
